import userStore from 'stores/user';
import { upsertWatchlist } from 'utils/watchlist/upsert';

let user;

userStore.subscribe((r) => {
	user = r;
});

export async function editWatchlist(symbol: string, watchlistData: string[], name: string) {
	if (user._id) {
		let tempData;
		if (watchlistData.includes(symbol)) {
			tempData = watchlistData.filter((item) => item !== symbol);
		} else {
			tempData = [...watchlistData, symbol];
		}
		await upsertWatchlist(user._id, tempData, name);
	}
}
